import { SWITCH_ADDITIONAL_ACCOUNT } from './switchAdditionalAccount';
import { GET_ADDITIONAL_ACCOUNT_LIST } from './getAdditionalAccountList';
import { GET_ADDITIONAL_ACCOUNT_OPTIONS } from './getAdditionalAccountOptions';
import { CHECK_IS_SWITCH_ACCOUNTS_ENABLED } from './checkIsSwitchAccountsEnabled';

export * from './useUserAdditionalAccounts';
export * from './useUserAdditionalAccountsCheck';

export const userAdditionalAccountsApi = {
  getList: GET_ADDITIONAL_ACCOUNT_LIST,
  getOptions: GET_ADDITIONAL_ACCOUNT_OPTIONS,
  checkIsSwitchAccountsEnabled: CHECK_IS_SWITCH_ACCOUNTS_ENABLED,

  switchAccount: SWITCH_ADDITIONAL_ACCOUNT,
};
